import { arrowRight } from 'assets';
import { TableGroup } from 'components';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 start
// import TableGantt from 'containers/TableGantt';
// 2023/10/10 Leading Win 作業員シフト表廃止対応 end
import { isNull } from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { siteService } from 'services';
import { GetStatusKyResponse, SiteItem } from 'types';
import { siteListSelector } from './selectors';
import StyledSiteList from './styles';

type PropsSitesAgent = {
  isGetStatusKy?: boolean;
};

const SitesAgent: FC<PropsSitesAgent> = ({ isGetStatusKy = false }) => {
  const {
    sitesCharge,
    // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start
    error_message,
    // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end
  } = useSelector(siteListSelector);
  const history = useHistory();
  // 2023/11/22 Leading Win 作業員シフト表廃止対応 DXWEBLOS00300 担当現場一覧 start
  const [data, setData] = useState<SiteItem[]>([]);

  useEffect(() => {
    if (!sitesCharge?.sites?.length) {
      return;
    }
    const arr: SiteItem[] = sitesCharge.sites.map((u) => {
      return {
        ...u,
        building_code: `${u.building_code?.split('-')[0]}-${u.building_code?.split('-')[1]}` ?? '',
      };
    });
    setData(arr);
  }, [sitesCharge]);
  // 2023/11/22 Leading Win 作業員シフト表廃止対応 DXWEBLOS00300 担当現場一覧 end

  return (
    <StyledSiteList>
      {/* 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 start */}
      {error_message && <p className="error-message">{error_message}</p>}
      {/* 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00300_担当現場一覧 end */}
      <TableGroup
        columns={columns(history, isGetStatusKy)}
        // 2023/11/22 Leading Win 作業員シフト表廃止対応 DXWEBLOS00300 担当現場一覧 start
        // dataSource={sitesCharge.sites || []}
        dataSource={data || []}
        // 2023/11/22 Leading Win 作業員シフト表廃止対応 DXWEBLOS00300 担当現場一覧 end
        loading={sitesCharge.loading}
        expandedRowRender={(e: SiteItem, index, intend, explained) => {
          // 2023/10/10 Leading Win 作業員シフト表廃止対応 start
          // return <TableGantt building_id={e.building_id} />;
          return [];
          // 2023/10/10 Leading Win 作業員シフト表廃止対応 end
        }}
      />
    </StyledSiteList>
  );
};
// export function useGetStatus(building_id: string) {
//   const [status, setStatus] = useState<null | number>(null);
//   const [date] = useState<string>(dayjs().format('YYYY-MM-DD'));
//   useEffect(() => {
//     async function getStatus() {
//       try {
//         const { data } = await siteService.getSiteActiveStatus({ building_id, date });
//         setStatus(data?.status_active);
//       } catch (error) {
//         console.error(error);
//       }
//     }
//     getStatus();
//   }, [building_id, date]);
//   return status;
// }
function UseGetStatusKy(building_id: string) {
  const [status, setStatus] = useState<GetStatusKyResponse>();
  useEffect(() => {
    async function getStatus() {
      try {
        //setStatus(undefined);
        const { data } = await siteService.getStatusKy({
          date: new Date(),
          building_id,
        });
        setStatus(data);
        console.log('リフレッシュ');
      } catch (error) {
        console.error(error);
      }
    }
    getStatus();
  }, [building_id]);
  return status;
}

const columns = (history: RouteComponentProps['history'], isGetStatusKy: boolean) => {
  if (isGetStatusKy) {
    return [
      {
        title: '作業状況',
        dataIndex: 'status_active',
        width: '90px',
        className: 'boder-none',
        render: (status_active: number) => {
          return <TableGroup.StatusJobFC status={status_active} />;
        },
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: '工事コード',
        dataIndex: 'building_code',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: '現場名',
        dataIndex: 'site_name',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: '現場住所',
        dataIndex: 'site_address',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: '工事担当者',
        dataIndex: 'site_director_name',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: '商品',
        dataIndex: 'product_name',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        title: 'RKY状況 ',
        dataIndex: 'worker_check_flag',
        className: 'boder-none',
        render: (_: any, record: SiteItem) => {
          // const status = UseGetStatusKy(building_id);
          // return (
          //   <TableGroup.StatusRkyFC
          //     status={status?.director_approval_flag}
          //     numberNotAprove={status?.sites_total}
          //   />
          // );
          const approvalFlag =
            record.director_approval_flag != null && record.director_approval_flag !== ''
              ? Number(record.director_approval_flag)
              : undefined;
          if (record.worker_check_flag === '1') {
            return (
              <TableGroup.StatusRkyFC status={approvalFlag} numberNotAprove={record.sites_total} />
            );
          }
          return null;
        },
        width: '120px',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
      {
        render: ({ site_id, building_id }: { site_id: string; building_id: string }) => {
          return (
            <div
              className="cursor-pointer"
              onClick={() => history.push(`/site/${site_id}/building/${building_id}/work-status`)}
            >
              <img src={arrowRight} alt="" />
            </div>
          );
        },
        width: '5%',
        onCell: () => ({
          style: {
            cursor: 'default',
          },
        }),
      },
    ];
  }
  return [
    {
      title: '作業状況',
      dataIndex: 'status_active',
      width: '90px',
      className: 'boder-none',
      render: (status_active: number) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        // const status = useGetStatus(building_id);
        return <TableGroup.StatusJobFC status={status_active} />;
      },
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
    {
      title: '工事コード',
      dataIndex: 'building_code',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
    {
      title: '現場名',
      dataIndex: 'site_name',
      width: '22%',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
    {
      title: '現場住所',
      dataIndex: 'site_address',
      width: '22%',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
    {
      title: '工事担当者',
      dataIndex: 'site_director_name',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
    {
      title: '商品',
      dataIndex: 'product_name',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },

    {
      render: ({ site_id, building_id }: { site_id: string; building_id: string }) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => history.push(`/site/${site_id}/building/${building_id}/work-status`)}
            style={{ cursor: 'pointer' }}
          >
            <img src={arrowRight} alt="" />
          </div>
        );
      },
      width: '5%',
      onCell: () => ({
        style: {
          cursor: 'default',
        },
      }),
    },
  ];
};
export default SitesAgent;
